/**
 * Checks if the start of an annotation is within a particular node.
 *
 * @param {Array<object>} startingAnnotations
 * @param {Array<object>} parentStartingAnnotations
 * @param {object} node
 * @param {object} annotation
 * @returns {boolean}
 */
const getDoesAnnotationStartInThisNode = (
  startingAnnotations,
  parentStartingAnnotations,
  node,
  annotation,
) => {
  if (node.identifier && annotation.start !== node.identifier) {
    return false;
  }

  const annotationStartingRelativeToCurrentNode = startingAnnotations.find(
    ({ id }) => annotation.id === id,
  );

  if (annotationStartingRelativeToCurrentNode) {
    return true;
  }

  const doesAnnotationStartRelativeToParentNode = Boolean(
    parentStartingAnnotations.find(({ id }) => annotation.id === id),
  );

  const isAnnotationStartInRangeOfNodeOffset =
    annotation.startoffset >= node.startOffset &&
    annotation.startoffset <= node.endOffset;

  return (
    doesAnnotationStartRelativeToParentNode &&
    isAnnotationStartInRangeOfNodeOffset
  );
};

export default getDoesAnnotationStartInThisNode;
